<template>
    <div class="category-aside">
        <strong class="category-aside__title h3">{{ title }}</strong>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped lang="scss">
.category-aside {
    margin-bottom: 4rem;

    @media #{$media-to-sm} {
        margin-bottom: 3rem;
    }

    &__title {
        display: block;
        margin-bottom: 1.5rem;
        padding-bottom: 1.5rem;
        margin-bottom: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px solid $sherpa-blue-light;
        color: $blue-dianne;

        &.h3 {
            font-size: 20px;
            font-weight: 500;
            line-height: 20px;
        }

        @media #{$media-to-sm} {
            margin-bottom: 1.5rem;
            padding-bottom: 1.5rem;
        }
    }
}
.filter-list {
    .category-aside__title {
        margin-bottom: 0;
        @media #{$media-to-sm} {
            margin-top: 1.5rem;
        }
    }
}
</style>
